import { render } from "./AdminAnnouncements.vue?vue&type=template&id=16f284e2"
import script from "./AdminAnnouncements.vue?vue&type=script&lang=js"
export * from "./AdminAnnouncements.vue?vue&type=script&lang=js"

import "./AdminAnnouncements.vue?vue&type=style&index=0&id=16f284e2&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__